import type { ComponentWithAs, IconProps } from "@chakra-ui/react";
import { ScannerIcon, UploadIcon } from "./Icons";

type Config = {
  icon: ComponentWithAs<"svg", IconProps>;
  textKey: string;
  eventLabel: "CheckYourCompensationBarcode" | "CheckYourCompensationUploader";
  destination: "webappBarcodeScanner" | "webappBarcodeUploader";
};

export const config: Record<"uploader" | "scanner", Config> = {
  uploader: {
    eventLabel: "CheckYourCompensationUploader",
    destination: "webappBarcodeUploader",
    textKey: "upload_boarding_pass",
    // TODO | Replace with RUIC UploadIcon once it will be available
    icon: UploadIcon,
  },
  scanner: {
    eventLabel: "CheckYourCompensationBarcode",
    destination: "webappBarcodeScanner",
    textKey: "scan_your_boarding_pass_barcode",
    // TODO | Replace with RUIC UploadIcon once it will be available
    icon: ScannerIcon,
  },
};
